"use strict";
/*
Copyright 2018 - 2022 The Alephium Authors
This file is part of the alephium project.

The library is free software: you can redistribute it and/or modify
it under the terms of the GNU Lesser General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

The library is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Lesser General Public License for more details.

You should have received a copy of the GNU Lesser General Public License
along with the library. If not, see <http://www.gnu.org/licenses/>.
*/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checksum = void 0;
const utils_1 = require("../utils");
const djb2_1 = __importDefault(require("../utils/djb2"));
const int_as_4bytes_codec_1 = require("./int-as-4bytes-codec");
const codec_1 = require("./codec");
class Checksum extends codec_1.Codec {
    constructor(rawCodec) {
        super();
        this.rawCodec = rawCodec;
    }
    encode(value) {
        const rawEncoded = this.rawCodec.encode(value);
        const checksum = int_as_4bytes_codec_1.intAs4BytesCodec.encode((0, djb2_1.default)(rawEncoded));
        return (0, utils_1.concatBytes)([rawEncoded, checksum]);
    }
    _decode(input) {
        const fromIndex = input.getIndex();
        const rawDecoded = this.rawCodec._decode(input);
        const toIndex = input.getIndex();
        const checksum = int_as_4bytes_codec_1.intAs4BytesCodec._decode(input);
        const expected = (0, djb2_1.default)(input.getBytes(fromIndex, toIndex));
        if (expected != checksum) {
            throw new Error(`Invalid checksum: expected ${expected}, but got ${checksum}`);
        }
        return rawDecoded;
    }
}
exports.Checksum = Checksum;
